export const BrowserPreview = ({ html, title, css }) => {
  const content = css ? `<style>${css}</style>${html}` : html;

  return (
    <div className="my-4 rounded-xl overflow-hidden border border-[#00CED1]/30" data-testid="browser-preview">
      <div className="flex items-center gap-2 px-4 py-2 bg-[#1a1a2e] border-b border-[#00CED1]/20">
        <div className="flex gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-[#ff5f56]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#ffbd2e]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#27c93f]" />
        </div>
        <span className="text-xs font-mono text-[#00CED1] tracking-wider uppercase ml-2">
          {title || 'Browser'}
        </span>
      </div>
      <div
        className="p-4 bg-white min-h-[60px] browser-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export const VSCodeTask = ({ task }) => (
  <div className="my-6 rounded-2xl overflow-hidden border border-[#9333EA]/30 bg-[#9333EA]/10" data-testid="vscode-task">
    <div className="px-5 py-3 bg-[#9333EA]/20 border-b border-[#9333EA]/20">
      <h3 className="font-outfit font-bold text-[#C084FC] text-base">
        {task.title || 'VS Code Task'}
      </h3>
    </div>
    <div className="p-5">
      <ol className="space-y-3">
        {task.steps.map((step, i) => (
          <li key={i} className="flex gap-3">
            <span className="shrink-0 w-6 h-6 rounded-full bg-[#9333EA]/30 text-[#C084FC] text-xs font-bold flex items-center justify-center">
              {i + 1}
            </span>
            <span className="text-[#E4E4E7] text-sm font-quicksand leading-relaxed">{step}</span>
          </li>
        ))}
      </ol>
    </div>
  </div>
);

export const ChallengeBlock = ({ challenge }) => (
  <div className="my-6 rounded-2xl overflow-hidden border border-[#FF0099]/30 bg-[#FF0099]/10" data-testid="challenge-block">
    <div className="px-5 py-3 bg-[#FF0099]/20 border-b border-[#FF0099]/20">
      <h3 className="font-outfit font-bold text-[#FF66C4] text-base">
        {challenge.title || 'Challenge'}
      </h3>
    </div>
    <div className="p-5">
      <p className="text-[#E4E4E7] text-sm font-quicksand leading-relaxed">{challenge.description}</p>
    </div>
  </div>
);
